import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cloneDeep from 'lodash.clonedeep';
import { DistributorsConfigFormTemplateFormSectionName, FormTemplateSection } from 'data/template/template.types';
import { ChangedField, FieldUpdateHandlerParam } from 'shared/form';
// import { useDialedDigitExtractionServerFieldCreateNew }
// from 'routes/DialedDigitExtractionServer/hooks/useDialedDigitExtractionServerFieldCreateNew';
import { FormLayoutContent, FormLayoutFooter, FormLayout } from 'components/FormLayout';
import FormButtons from 'components/FormButtons';
import FormPanel from 'components/FormPanel';
import DialedDigitExtractionServerForm from 'routes/DialedDigitExtractionServer/components/DialedDigitExtractionServerForm';
import { Ref } from 'routes/DialedDigitExtractionServer/components/DialedDigitExtractionServerForm/DialedDigitExtractionServerForm';
import * as dialedDigitExtractionServerSelectors from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.selectors';
import { RootState } from 'data/root.reducers';
import * as dialedDigitExtractionServerActions from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.actions';
import { ConnectedProps, connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as securityInfoActions from 'data/securityInfo/securityInfo.actions';
import * as discoverySelectors from 'xcipio/discovery-xcipio-selectors';
import * as authenticationSelectors from 'data/authentication/authentication.selectors';
import { DialedDigitExtractionServer } from 'data/dialedDigitExtractionServer/dialedDigitExtractionServer.types';
import { dialedDigitExtractionServerTemplate } from '../../templates';
import { adaptNetworkIdField, adaptTemplateVisibilityMode } from '../../utils/dialedDigitExtractionServerTemplate.adapter';
import { getAuditDetailsToSubmit } from '../../utils/dialedDigitExtractionServerDataToSubmit';

type RouterParams = {
  history: string
}
const mapState = (state: RootState) => ({
  deliveryFunctionId: state.global.selectedDF,
  selectedDialedDigitExtractionServer: dialedDigitExtractionServerSelectors
    .getSelectedDialedDigitExtractionServer(state)[0],
  originalSelectedDialedDigitExtractionServer: dialedDigitExtractionServerSelectors
    .getSelectedDialedDigitExtractionServer(state)[0],
  dialedDigitExtractionServer: dialedDigitExtractionServerSelectors.getDialedDigitExtractionServer(state),
});

const mapDispatch = {
  getSecurityInfos: securityInfoActions.getSecurityInfos,
  goToDialedDigitExtractionServerList: dialedDigitExtractionServerActions.goToDialedDigitExtractionServerList,
  goToDialedDigitExtractionServerEdit: dialedDigitExtractionServerActions.goToDialedDigitExtractionServerEdit,
  getDialedDigitExtractionServer: dialedDigitExtractionServerActions.getDialedDigitExtractionServer,
};
const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>
type PropsFromRouter = RouteComponentProps<RouterParams>

export type Props = PropsFromRedux & PropsFromRouter;

export const DialedDigitExtractionServerView = ({
  history,
  selectedDialedDigitExtractionServer,
  deliveryFunctionId,
  goToDialedDigitExtractionServerList,
  goToDialedDigitExtractionServerEdit,
  getDialedDigitExtractionServer,
}: Props): JSX.Element => {

  const formRef = useRef<Ref>(null);
  const [formData, setFormData] = useState<Partial<DialedDigitExtractionServer>>({});
  const [template, setTemplate] = useState(adaptTemplateVisibilityMode(dialedDigitExtractionServerTemplate, 'view'));
  const { t } = useTranslation();

  const id = selectedDialedDigitExtractionServer?.id;

  useEffect(() => {
    if (id) {
      getDialedDigitExtractionServer(deliveryFunctionId, id);
    }
  }, [deliveryFunctionId, id, getDialedDigitExtractionServer]);

  useEffect(() => {
    if (selectedDialedDigitExtractionServer != null && template != null) {
      setFormData(selectedDialedDigitExtractionServer);

      const clonedTemplate = cloneDeep(template);
      clonedTemplate.formId = Date.now().toString();
      clonedTemplate.main = adaptNetworkIdField(template.main as FormTemplateSection, selectedDialedDigitExtractionServer);
      setTemplate(clonedTemplate);
    }
  }, [selectedDialedDigitExtractionServer, id]);

  const handleClickEdit = () => goToDialedDigitExtractionServerEdit(history);

  const handleCancel = () => goToDialedDigitExtractionServerList(history);

  const handleFieldUpdate = ({ name: fieldName, value }: FieldUpdateHandlerParam) => {
    if (formData != null) {
      return;
    }

    const clonedFormData = cloneDeep(formData as DialedDigitExtractionServer);

    setFormData({
      ...clonedFormData,
      [fieldName]: value,
    });
  };

  const renderForm = () => {
    if (formData && template) {
      return (
        <DialedDigitExtractionServerForm
          ref={formRef}
          data={formData}
          template={template}
          isEditing
          onFieldUpdate={handleFieldUpdate}
        />
      );
    }
  };
  const renderFormPanel = (formTitle:string) => {
    return (
      <FormPanel title={t('dialedDigitExtractionServer.view.title')}>
        <FormButtons
          isEditing={false}
          onClickCancel={handleCancel}
          onClickEdit={handleClickEdit}
          onClickClose={handleCancel}
        />
      </FormPanel>
    );
  };

  return (
    <div data-testid="DdeServerView">
      <FormLayout>
        <FormLayoutContent>
          {renderFormPanel(t('ss8Distributor.view.title'))}
          {renderForm()}
        </FormLayoutContent>
      </FormLayout>
    </div>
  );
};

export default withRouter(connector(DialedDigitExtractionServerView));
